import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BeanJustificativa } from 'src/bean/BeanJustificativa';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JustificationService {

  constructor(
    private http: HttpClient
  ) { }

  public getHeaders(){

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization' : 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return headers;
  }

  public listarJustificativa():Promise<any> {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.listarJustificativa}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  public listarJustificativasAtivas():Promise<any> {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.listarJustificativasAtivas}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  public getJustificativa(id:string):Promise<any>{

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.getJustificativa}${id}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  addJustificativa(formModel: BeanJustificativa):Promise<any>{
    return this.gravarJustificativa(formModel).toPromise().then((resposta:any) => resposta);
  }

  public gravarJustificativa(formModel: BeanJustificativa){

    const headers = this.getHeaders();

    let json = JSON.stringify(formModel);

    return this.http.post(`${environment.urlBackend}${environment.criarJustificativa}`,json, {headers});
  }

  updateJustificativa(formModel: BeanJustificativa):Promise<any>{
    return this.atualizarJustificativa(formModel).toPromise().then((resposta:any) => resposta);
  }

  public atualizarJustificativa(formModel: BeanJustificativa){

    const headers = this.getHeaders();

    let json = JSON.stringify(formModel);

    return this.http.put(`${environment.urlBackend}${environment.updateJustificativa}${formModel.justIdCdJustificativa}`, json, {headers});
  }
}
